import genericCarsEU from "json/genericEU.json";
import { map } from "lodash/fp";
import genericCarsUS from "json/genericUS.json";
import { genericCarToCar } from "libraries/car";
import { CarState } from "types/cars";

type ReturnType = {
  getLocalCars: () => CarState[];
};

const DEFAULT_CARS_SET = genericCarsUS;

export const getLocalCars = (): CarState[] => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const isEU =
    userTimezone.startsWith("Europe") ||
    userTimezone.startsWith("Atlantic/Azores") ||
    userTimezone.startsWith("Africa/Casablanca");

  const isUS = userTimezone.startsWith("America");

  console.log(`[GenericCars] Timezone region US [${isUS}] ; EU [${isEU}]`);

  const genericCarsSet = isEU
    ? genericCarsEU
    : isUS
      ? genericCarsUS
      : DEFAULT_CARS_SET;

  return map(genericCarToCar)(genericCarsSet);
};

const useGenericCars = (): ReturnType => {
  return { getLocalCars };
};

export default useGenericCars;
